import { useEffect, useRef } from 'react';
import { recordUserAction } from '../utils/awsRum';

/**
 * フォーム離脱検知 Hook
 *
 * isDirty が true の状態でページを離脱した場合に
 * `form_abandoned` イベントを CloudWatch RUM に送信する。
 *
 * 検知する離脱パターン:
 * - ブラウザのタブ/ウィンドウを閉じる（beforeunload）
 * - コンポーネントのアンマウント（アプリ内ナビゲーション）
 */
export function useAbandonmentDetection(
  formName: string,
  isDirty: boolean,
): void {
  const isDirtyRef = useRef(isDirty);
  isDirtyRef.current = isDirty;

  useEffect(() => {
    const handleBeforeUnload = () => {
      if (isDirtyRef.current) {
        recordUserAction('form_abandoned', { form: formName, trigger: 'beforeunload' });
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);

      // アンマウント時（アプリ内ナビゲーション）に未保存なら離脱扱い
      if (isDirtyRef.current) {
        recordUserAction('form_abandoned', { form: formName, trigger: 'unmount' });
      }
    };
  }, [formName]);
}
